module.exports = __webpack_public_path__ + "img/solution-cockpit01-function-pic.910c8698.png";